import { render, staticRenderFns } from "./NewRegionModal.vue?vue&type=template&id=42046a8d&"
import script from "./NewRegionModal.vue?vue&type=script&lang=js&"
export * from "./NewRegionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports